import React from "react";
import "./Common_Product_Card.css";
import { useNavigate } from "react-router-dom";
import { encodeId } from "../../../utils/common";

const Common_Product_Card = ({ imgsrc, prodTitle, price, id }) => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        className="Common_Product_Card"
        onClick={() => navigate(`/vendor-page/${encodeId(id)}`)}
      >
        <div className="img_holder">
          <img src={process.env.PUBLIC_URL + imgsrc} className="prod_img" />
        </div>
        <div className="text_holder">
          <p className="title">{prodTitle}</p>
          <p className="price">₹{price}</p>
        </div>
      </div>
    </div>
  );
};

export default Common_Product_Card;
